var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7679 0H2.73214C2.00753 0 1.3126 0.28785 0.800226 0.800226C0.28785 1.3126 0 2.00753 0 2.73214L0 22.7679C0 23.4925 0.28785 24.1874 0.800226 24.6998C1.3126 25.2122 2.00753 25.5 2.73214 25.5H10.544V16.8308H6.96191V12.75H10.5481V9.63981C10.5481 6.10219 12.6529 4.148 15.8796 4.148C16.9373 4.16276 17.9925 4.25475 19.0368 4.42324V7.89286H17.2558C16.9525 7.85269 16.6441 7.88123 16.3533 7.97636C16.0626 8.07148 15.7969 8.23076 15.576 8.44241C15.3551 8.65406 15.1846 8.91267 15.0771 9.1991C14.9697 9.48554 14.928 9.79247 14.9551 10.0972V12.75H18.87L18.2442 16.8308H14.956V25.5H22.7679C23.4925 25.5 24.1874 25.2122 24.6998 24.6998C25.2122 24.1874 25.5 23.4925 25.5 22.7679V2.73214C25.5 2.00753 25.2122 1.3126 24.6998 0.800226C24.1874 0.28785 23.4925 0 22.7679 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic_fb.7e0fb812bef6c1e06247434f7d1cc965.svg";
export { ForwardRef as ReactComponent };